<template>
  <tr>
    <td class="middle text-right" colspan="3">
      <b>RAZEM:</b>
    </td>

    <w-table-cell class="text-right middle" :model="model.plnSum">
      <w-preview :model="model.plnSum" />
    </w-table-cell>

    <w-table-cell class="text-right middle" :model="model.euroSum">
      <w-preview :model="model.euroSum" />
    </w-table-cell>

    <td />
  </tr>
</template>

<script>
import components from '@witkac/bootstrap4-components';
// @vuese
// @De Minimis Sum
// @Group formStaticComponents
export default {
  components,
  props: {
    // Przekazana wartośc do wyświetlenia
    model: { type: Object, required: true }
  }
};
</script>
